import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { CategoryServicee } from "../../../store/category/categoryService";
import categorySlice from "../../../store/category/categoryRedux";
import { Pagination } from "../../../shared/paginations/Paginations";
import { Table } from "react-bootstrap";
import { t } from "i18next";
import {
  correctFormatTable,
  formatDate,
  formatDateWorkflowDead,
  getCorrectStatus,
} from "../../../shared/functions/Functions";
import { EmptyState } from "../../../shared/components/EmptyState";
import { ApiService } from "../../api/service";
import { Tooltip } from "react-tooltip";
import { ClientService } from "../service";
export const Send = () => {
  const { id } = useParams();
  const initialPagination = {
    page: 1,
    perPage: 10,
    client: Number(id),
    name: null,
    status: "pending",
  };

  const dispatch = useDispatch();
  const [completeTab, setCompleteTab] = useState(false);
  const [workflowList, setWorkflowList] = useState<any[] | undefined>();
  const { accessRights } = useSelector((state: IAllStates) => state.auth);
  const [completedList, setCompletedList] = useState<any[] | undefined>();
  const currentUser = JSON.parse(localStorage.getItem("currentUser") as string);
  const isManager = currentUser?.roles?.includes("ROLE_MANAGER");
  const isAdmin = currentUser?.roles?.includes("ROLE_ADMIN");
  const isCompanyAdmin = currentUser?.roles?.includes("ROLE_COMPANY_ADMIN");
  const [pagination, setPagination] = useState(initialPagination);
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const [completeName, setCompleteName] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const handlePages = (updatePage: number) => {
    setPagination({ ...pagination, page: updatePage });
    setPage(updatePage);
  };
  const lightOrDarkMode = useSelector(
    (state: IAllStates) => state.lightOrDarkMode
  );
  const [clientName, setClientName] = useState({});
  const [paginationCompleted, setPaginationCompleted] = useState({
    page: 1,
    perPage: 10,
    client: Number(id),
    name: null,
    status: "sent",
  });
  const [pageCompleted, setPageCompleted] = useState(1);
  const [totalPagesCompleted, setTotalPagesCompleted] = useState(0);

  const handlePagesCompleted = (updatePage: number) => {
    setPaginationCompleted({ ...paginationCompleted, page: updatePage });
    setPageCompleted(updatePage);
  };

  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const handleDownload = (file: any, name: string) => {
    // files.forEach((file: any) => {
    const xhr = new XMLHttpRequest();
    const fileName = name;
    xhr.open("GET", file, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = new Blob([xhr.response], { type: "application/*" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName ?? "";
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }, 0);
      }
    };
    xhr.send();
    // });
  };
  useEffect(() => {
    setName("");
    setCompleteName("");
  }, [completeTab]);
  useEffect(() => {
    if (completeTab) {
      ApiService.getAllTasks({
        ...paginationCompleted,
        status: "sent",
        name: (completeName as any)?.value ?? "",
      })
        .then((response) => {
          // setPagination(initialPagination);
          const { data } = response;
          setTotalPagesCompleted(
            Math.ceil(response?.count / response?.perPage)
          );
          setCompletedList(data);
          setPageCompleted(response?.page);
        })
        .catch((error) => ErrorToast(error));
    } else {
      ApiService.getAllTasks({
        ...pagination,
        name: (name as any)?.value ?? "",
        status: "pending",
      })
        .then((response) => {
          const { data } = response;
          // !completeTab && setPaginationCompleted(initialPagination);
          setTotalPages(Math.ceil(response?.count / response?.perPage));
          setPage(response?.page);
          setWorkflowList(data);
        })
        .catch((error) => ErrorToast(error));
    }
  }, [
    pagination,
    paginationCompleted,
    triggerUpdate,
    completeTab,
    name,
    completeName,
  ]);
  useEffect(() => {
    ClientService.getAllClients({ page: 1, perPage: 0 })
      .then((response) => {
        const { data } = response;
        setClientName(
          data?.length > 0
            ? (data as any)
                ?.map((user: any) => ({
                  name: user?.name,
                  value: user?.id,
                }))
                ?.find((user: any) => user?.value == id)
            : {}
        );
      })
      .catch((error) => ErrorToast(error));
  }, []);
  useEffect(() => {
    CategoryServicee.getAllCategories()
      .then((data) => {
        dispatch(categorySlice.actions.setCategory(data));
      })
      .catch((error) => ErrorToast(error));
  }, []);
  return (
    <>
      <div className="col-md-12">
        <div className="d-flex justify-content-between align-items-center">
          <button
            className="btn btn-info mb-3 d-flex align-items-center"
            onClick={() => navigate("/app/clients")}
          >
            <i className="ri-arrow-left-line"></i>
            <span className="ms-1">{t("global.back")}</span>
          </button>
          <h4>{(clientName as any)?.name ?? ""}</h4>
        </div>
      </div>
      <div className="card">
        <div className="card-header pb-0">
          <div className="d-flex justify-content-start">
            <h4 className="card-title mg-b-0">{t("workflow.workflows")}</h4>
          </div>
        </div>
        <div className="card-body">
          {true && (
            <>
              <ul className="nav nav-tabs mb-3" role="tablist">
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link active"
                    data-bs-toggle="tab"
                    href="#home"
                    role="tab"
                    aria-selected="true"
                    tabIndex={-1}
                    onClick={() => setCompleteTab((prev: boolean) => !prev)}
                  >
                    {t("global_v2.queue")}
                  </a>
                </li>
                {(isAdmin || isCompanyAdmin || isManager) && (
                  <li className="nav-item" role="presentation">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      href="#product1"
                      role="tab"
                      aria-selected="false"
                      onClick={() => setCompleteTab((prev: boolean) => !prev)}
                    >
                      {t("global_v2.history")}
                    </a>
                  </li>
                )}
              </ul>
              {/* Tab panes */}
              <div className="tab-content  text-muted">
                <div className="tab-pane active" id="home" role="tabpanel">
                  {/* {list?.length === 0 ? (
                            <EmptyState />
                          ) : ( */}
                  {workflowList?.length === 0 ? (
                    <EmptyState />
                  ) : (
                    <>
                      {/* ovdje */}
                      <p className="mb-0">
                        <div className="table-responsive">
                          <Table className="align-middle table-nowrap mb-0">
                            <thead className="table-light">
                              <tr>
                                <th scope="col">{`${t("global.id")}`}</th>
                                <th scope="col">{`${t("workflow.name")}`}</th>
                                <th scope="col">{`${t("global.status")}`}</th>
                                <th scope="col">{`${t(
                                  "global_v2.emails"
                                )}`}</th>
                                <th scope="col">{`${t(
                                  "products.createdAt"
                                )}`}</th>
                                <th scope="col">{`${t("global.action")}`}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {workflowList?.map((task) => {
                                return (
                                  <tr key={task?.id}>
                                    <td>
                                      <Link to="#" className="fw-medium">
                                        #{task?.id}
                                      </Link>
                                    </td>
                                    <td>
                                      {
                                        task?.clientProfileExportData?.workflow
                                          ?.name
                                      }
                                    </td>
                                    <td>{`${t(
                                      `status_workflow.${task?.status?.toUpperCase()}`
                                    )}`}</td>
                                    <td
                                      className="p-0"
                                      style={{ lineHeight: "1.2" }}
                                    >
                                      {task?.clientProfileExportData
                                        ?.clientProfile?.client?.emails
                                        ?.length > 0 ? (
                                        <>
                                          <div>
                                            {task?.clientProfileExportData?.clientProfile?.client?.emails
                                              .slice(0, 2)
                                              .map(
                                                (
                                                  email: string,
                                                  index: number
                                                ) => (
                                                  <div key={index}>{email}</div>
                                                )
                                              )}
                                          </div>
                                          {task?.clientProfileExportData
                                            ?.clientProfile?.client?.emails
                                            ?.length > 2 && (
                                            <>
                                              <a
                                                data-tooltip-id={`my-tooltip-data-html-${task?.id}`}
                                                data-tooltip-html={task?.clientProfileExportData?.clientProfile?.client?.emails
                                                  .slice(
                                                    2,
                                                    task
                                                      ?.clientProfileExportData
                                                      ?.clientProfile?.client
                                                      ?.emails?.length
                                                  )
                                                  .map(
                                                    (email: string) =>
                                                      `<div>${email}</div>`
                                                  )
                                                  .join("")}
                                              >
                                                <span className="fw-bold">
                                                  {t(
                                                    "cilent_profile_export_tasks.hover_for_more"
                                                  )}
                                                </span>
                                              </a>
                                              <Tooltip
                                                id={`my-tooltip-data-html-${task?.id}`}
                                              />
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        <span>-</span>
                                      )}
                                    </td>
                                    <td>{formatDate(task?.createdAt)}</td>
                                    <td className="d-flex justify-content-center">
                                      {/* <button
                                      onClick={() => handleSend(task?.id)}
                                      className="btn btn-sm  btn-secondary d-flex align-items-center"
                                    >
                                      {t("global_v2.send")}
                                    </button> */}
                                      <button
                                        onClick={() =>
                                          handleDownload(
                                            task?.filePath,
                                            task?.fileName
                                          )
                                        }
                                        className="btn btn-sm  btn-secondary d-flex align-items-center"
                                        // disabled={!brand?.documents}
                                        disabled={!task?.filePath}
                                      >
                                        <i className="ri-file-download-fill me-1" />
                                        {t("global.document")}
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </p>
                      {!completeTab && (
                        <div className="d-flex justify-content-end ">
                          {totalPages! <= 1 ? (
                            ""
                          ) : (
                            <Pagination
                              page={page!}
                              totalPages={totalPages!}
                              handlePagination={handlePages!}
                            />
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="tab-pane " id="product1" role="tabpanel">
                  {completedList?.length === 0 ? (
                    <EmptyState />
                  ) : (
                    <>
                      <p className="mb-0">
                        <div className="table-responsive">
                          <Table className="align-middle table-nowrap mb-0">
                            <thead className="table-light">
                              <tr>
                                <th scope="col">{`${t("global.id")}`}</th>
                                <th scope="col">{`${t("workflow.name")}`}</th>
                                <th scope="col">{`${t("global.status")}`}</th>
                                <th scope="col">{`${t(
                                  "global_v2.emails"
                                )}`}</th>
                                <th scope="col">{`${t(
                                  "products.createdAt"
                                )}`}</th>
                                <th scope="col">{`${t(
                                  "global_v2.sendAt"
                                )}`}</th>
                                {/* <th scope="col">{`${t("global.action")}`}</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {completedList?.map((task: any) => {
                                return (
                                  <tr key={task?.id}>
                                    <td>
                                      <Link to="#" className="fw-medium">
                                        #{task?.id}
                                      </Link>
                                    </td>
                                    <td>
                                      {
                                        task?.clientProfileExportData?.workflow
                                          ?.name
                                      }
                                    </td>
                                    <td>{`${t(
                                      `status_workflow.${task?.status?.toUpperCase()}`
                                    )}`}</td>
                                    <td
                                      className="p-0"
                                      style={{ lineHeight: "1.2" }}
                                    >
                                      {task?.clientProfileExportData
                                        ?.clientProfile?.client?.emails
                                        ?.length > 0 ? (
                                        <>
                                          <div>
                                            {task?.clientProfileExportData?.clientProfile?.client?.emails
                                              .slice(0, 2)
                                              .map(
                                                (
                                                  email: string,
                                                  index: number
                                                ) => (
                                                  <div key={index}>{email}</div>
                                                )
                                              )}
                                          </div>
                                          {task?.clientProfileExportData
                                            ?.clientProfile?.client?.emails
                                            ?.length > 2 && (
                                            <>
                                              <a
                                                data-tooltip-id={`my-tooltip-data-html-${task?.id}`}
                                                data-tooltip-html={task?.clientProfileExportData?.clientProfile?.client?.emails
                                                  .slice(
                                                    2,
                                                    task
                                                      ?.clientProfileExportData
                                                      ?.clientProfile?.client
                                                      ?.emails?.length
                                                  )
                                                  .map(
                                                    (email: string) =>
                                                      `<div>${email}</div>`
                                                  )
                                                  .join("")}
                                              >
                                                <span className="fw-bold">
                                                  {t(
                                                    "cilent_profile_export_tasks.hover_for_more"
                                                  )}
                                                </span>
                                              </a>
                                              <Tooltip
                                                id={`my-tooltip-data-html-${task?.id}`}
                                              />
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        <span>-</span>
                                      )}
                                    </td>
                                    <td>{formatDate(task?.createdAt)}</td>
                                    <td>
                                      {task?.sendAt
                                        ? formatDate(task?.sendAt)
                                        : "-"}
                                    </td>
                                    {/* <td className="d-flex justify-content-center">
                                    <button
                                      onClick={() => handleSend(task?.id)}
                                      className="btn btn-sm  btn-secondary d-flex align-items-center"
                                    >
                                      {t("global_v2.send")}
                                    </button>
                                  </td> */}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </p>
                      {completeTab && (
                        <div className="d-flex justify-content-end ">
                          {totalPagesCompleted! <= 1 ? (
                            ""
                          ) : (
                            <Pagination
                              page={pageCompleted!}
                              totalPages={totalPagesCompleted!}
                              handlePagination={handlePagesCompleted!}
                            />
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
